export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_08.0e571e69.png";